// @flow
import React, { useContext } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import RowLayout, { RowLayoutContent, HeaderContent, Header } from 'app/common/layouts/RowLayout';
import { OptionProp, OptionProps } from 'app/common/ui-next/option-props';

import FileView from './FileView';
import { StatementsContext, type StatementType } from './StatementsData';
import useStatementInfoViewData from './useStatementInfoViewData';
import styles from './StatementInfo.scss';


type Props = {
  statementId: number,
  // onInvalidStatement
}

const StatementInfo = ({ statementId }: Props) => {
  const { t } = useTranslation('statements');
  const timezone = useSelector(state => state.user.timezone, shallowEqual);
  const [[statements]] = useContext(StatementsContext);


  const currentStatement: StatementType = statements[String(statementId)];

  const [
    numberView,
    createdAtView,
    schoolTitleView,
    whomView,
    subjectView,
    contentView,
    files,
  ] = useStatementInfoViewData(currentStatement, timezone);


  return (
    <RowLayout className={styles.root} paddingfree>
      <HeaderContent>
        <Header className={styles.header}>{numberView}</Header>
        <span className={styles.createdDate}>{createdAtView}</span>
      </HeaderContent>
      <RowLayoutContent>
        <OptionProps>
          <OptionProp title={t('school_name_field_label')}>
            {schoolTitleView}
          </OptionProp>
          <OptionProp title={t('whom_field_label')}>
            {whomView.map(({ id, title }) => (
              <div key={id}>{title}</div>
            ))}
          </OptionProp>
          <OptionProp title={t('subject_name_field_label')}>
            {subjectView}
          </OptionProp>
          <OptionProp title={t('content_field_label')}>
            {contentView}
          </OptionProp>
        </OptionProps>

        {files.map(({ id, name, thumb_url: thumbUrl, url }) => (
          <FileView
            key={id}
            name={name}
            className={styles.fileItem}
            urlThumb={thumbUrl}
            url={url}
          />
        ))}
      </RowLayoutContent>
    </RowLayout>
  );
};

export default StatementInfo;
